/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InvoiceContactInfoSnapshot } from './InvoiceContactInfoSnapshot';
import {
    InvoiceContactInfoSnapshotFromJSON,
    InvoiceContactInfoSnapshotFromJSONTyped,
    InvoiceContactInfoSnapshotToJSON,
    InvoiceContactInfoSnapshotToJSONTyped,
} from './InvoiceContactInfoSnapshot';
import type { InvoiceAddressSnapshot } from './InvoiceAddressSnapshot';
import {
    InvoiceAddressSnapshotFromJSON,
    InvoiceAddressSnapshotFromJSONTyped,
    InvoiceAddressSnapshotToJSON,
    InvoiceAddressSnapshotToJSONTyped,
} from './InvoiceAddressSnapshot';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';
import type { InvoiceDetailSnapshot } from './InvoiceDetailSnapshot';
import {
    InvoiceDetailSnapshotFromJSON,
    InvoiceDetailSnapshotFromJSONTyped,
    InvoiceDetailSnapshotToJSON,
    InvoiceDetailSnapshotToJSONTyped,
} from './InvoiceDetailSnapshot';

/**
 * 
 * @export
 * @interface SendStatementEmailRequest
 */
export interface SendStatementEmailRequest {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof SendStatementEmailRequest
     */
    userId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof SendStatementEmailRequest
     */
    userEmail: string;
    /**
     * 
     * @type {string}
     * @memberof SendStatementEmailRequest
     */
    userName: string;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof SendStatementEmailRequest
     */
    studentId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof SendStatementEmailRequest
     */
    studentName: string;
    /**
     * 
     * @type {string}
     * @memberof SendStatementEmailRequest
     */
    currency: string;
    /**
     * 
     * @type {string}
     * @memberof SendStatementEmailRequest
     */
    locationName: string | null;
    /**
     * 
     * @type {number}
     * @memberof SendStatementEmailRequest
     */
    totalAmount: number;
    /**
     * 
     * @type {Date}
     * @memberof SendStatementEmailRequest
     */
    billingDate: Date;
    /**
     * 
     * @type {Array<InvoiceDetailSnapshot>}
     * @memberof SendStatementEmailRequest
     */
    details: Array<InvoiceDetailSnapshot>;
    /**
     * 
     * @type {InvoiceAddressSnapshot}
     * @memberof SendStatementEmailRequest
     */
    address?: InvoiceAddressSnapshot | null;
    /**
     * 
     * @type {InvoiceContactInfoSnapshot}
     * @memberof SendStatementEmailRequest
     */
    contactInfo?: InvoiceContactInfoSnapshot | null;
}

/**
 * Check if a given object implements the SendStatementEmailRequest interface.
 */
export function instanceOfSendStatementEmailRequest(value: object): value is SendStatementEmailRequest {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('userEmail' in value) || value['userEmail'] === undefined) return false;
    if (!('userName' in value) || value['userName'] === undefined) return false;
    if (!('studentId' in value) || value['studentId'] === undefined) return false;
    if (!('studentName' in value) || value['studentName'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('locationName' in value) || value['locationName'] === undefined) return false;
    if (!('totalAmount' in value) || value['totalAmount'] === undefined) return false;
    if (!('billingDate' in value) || value['billingDate'] === undefined) return false;
    if (!('details' in value) || value['details'] === undefined) return false;
    return true;
}

export function SendStatementEmailRequestFromJSON(json: any): SendStatementEmailRequest {
    return SendStatementEmailRequestFromJSONTyped(json, false);
}

export function SendStatementEmailRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendStatementEmailRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': ApiUserTasksGetPageParameterFromJSON(json['userId']),
        'userEmail': json['userEmail'],
        'userName': json['userName'],
        'studentId': ApiUserTasksGetPageParameterFromJSON(json['studentId']),
        'studentName': json['studentName'],
        'currency': json['currency'],
        'locationName': json['locationName'],
        'totalAmount': json['totalAmount'],
        'billingDate': (new Date(json['billingDate'])),
        'details': ((json['details'] as Array<any>).map(InvoiceDetailSnapshotFromJSON)),
        'address': json['address'] == null ? undefined : InvoiceAddressSnapshotFromJSON(json['address']),
        'contactInfo': json['contactInfo'] == null ? undefined : InvoiceContactInfoSnapshotFromJSON(json['contactInfo']),
    };
}

export function SendStatementEmailRequestToJSON(json: any): SendStatementEmailRequest {
    return SendStatementEmailRequestToJSONTyped(json, false);
}

export function SendStatementEmailRequestToJSONTyped(value?: SendStatementEmailRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': ApiUserTasksGetPageParameterToJSON(value['userId']),
        'userEmail': value['userEmail'],
        'userName': value['userName'],
        'studentId': ApiUserTasksGetPageParameterToJSON(value['studentId']),
        'studentName': value['studentName'],
        'currency': value['currency'],
        'locationName': value['locationName'],
        'totalAmount': value['totalAmount'],
        'billingDate': value['billingDate'].toISOString().substring(0,10),
        'details': ((value['details'] as Array<any>).map(InvoiceDetailSnapshotToJSON)),
        'address': InvoiceAddressSnapshotToJSON(value['address']),
        'contactInfo': InvoiceContactInfoSnapshotToJSON(value['contactInfo']),
    };
}

